export const parsePreviewHash = <T>(hash: string): T | undefined => {
  const encoded = hash.replace(/^#/, '')
  if (!encoded) return undefined

  try {
    return JSON.parse(Buffer.from(encoded, 'base64').toString('utf8')) as T
  } catch {
    return undefined
  }
}
